import {data, useNavigate, useParams} from "react-router-dom";
import NavBar from "../../Component/NavBar/NavBar";
import {BiSolidUserDetail} from "react-icons/bi";
import React, {useEffect, useState} from "react";
import Loading from "../../Component/Loading/Loading";
import apiRequests from "../../Component/axios/config/config";
import LoadingSpan from "../../Component/Loading/LoadingSpan";
import {Pencil} from "lucide-react";
import {MdArrowBack} from "react-icons/md";


export default function InvoiceDetails() {

    const {id} = useParams()
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true)

    const [invoice, setInvoice] = useState({});

    useEffect(() => {

        setLoading(true)
        apiRequests.get(`/api/invoice/get-single-admin/${id}`)
            .then((response) => {
                const data = response.data.data;
                setInvoice(data);
            })
            .catch(() => {
            })
            .finally(() => setLoading(false));


    }, [id]);

    return (

        <div className="p-6 min-h-screen bg-gray-100 rounded-lg">
            <div className="text-3xl font-bold text-gray-800 mb-6">
                Invoice # {id.slice(0, 5)}
            </div>

            <div className="px-2">
                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center justify-center border-2 hover:bg-red-700 hover:text-white border-red-700 text-red-700 px-2 py-1 rounded-lg gap-1"
                >
                    <MdArrowBack/>
                    Back
                </button>
            </div>

            <div className="grid grid-cols-10 p-2 md:flex md:flex-col gap-3">

                <div className="col-span-8 bg-white rounded-lg p-3">

                    <div className="flex justify-center min">
                        <div className="w-full max-w-6xl md:overflow-x-auto">
                            <table className="w-full bg-white shadow-md rounded-lg overflow-hidden">
                                <thead
                                    className="bg-gradient-to-r text-left from-[#f1c40f] to-[#e94f7b] text-white">
                                <tr>
                                    <th className="px-6 py-3 text-left text-sm font-medium">Image</th>
                                    <th className="px-6 py-3 text-left text-sm font-medium">Name</th>
                                    <th className="px-6 py-3 text-left text-sm font-medium">Category</th>
                                    <th className="px-6 py-3 text-left text-sm font-medium">Price</th>
                                    <th className="px-6 py-3 text-left text-sm font-medium">Total Price</th>

                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                {loading ?
                                    <tr>
                                        <td className="px-4 py-3 text-center" colSpan="5">
                                            <Loading/>
                                        </td>
                                    </tr>
                                    :
                                    invoice.product_info.length > 0 ?
                                        invoice.product_info.map((item) =>
                                            <tr key={item._id} className="hover:cursor-pointer hover:bg-gray-200"
                                                onClick={() => navigate(`/product/${item.product}`)}>
                                                <td className="px-3 py-4 text-md font-medium rounded-tl-lg">
                                                    {/*{item.userName || "-"} */}
                                                    image
                                                </td>
                                                <td className="px-3 py-4 text-md font-medium">{item.name}</td>

                                                <td className="px-3 py-4 text-md font-medium">{item.category}</td>

                                                <td className="px-3 py-4 text-md font-medium rounded-tr-lg">
                                                    {item.price}
                                                </td>
                                                <td className="px-3 py-4 text-md font-medium rounded-tr-lg">
                                                    {(item.price * item.quantity).toFixed(2)}
                                                </td>
                                            </tr>
                                        )
                                        :
                                        <tr className="">
                                            <td className="px-4 py-3 text-center" colSpan="5">Product not found!</td>
                                        </tr>
                                }


                                </tbody>
                            </table>
                        </div>
                    </div>


                </div>
                <div className="col-span-2 flex flex-col gap-3">

                    <div className="flex flex-col bg-white p-3 rounded-lg items-center gap-2">
                        <span>Total Price :</span>
                        {loading ?
                            <LoadingSpan/>
                            :
                            <span className="font-bold text-baseColor-button">$ {invoice.totalAmount}</span>
                        }

                    </div>
                    <div className="flex flex-col bg-white p-3 rounded-lg items-center gap-2">
                        <span>Create At :</span>
                        {loading ?
                            <LoadingSpan/>
                            :
                            <span
                                className="font-bold text-baseColor-button">{new Date(invoice.createdAt).toLocaleString("en")}</span>
                        }
                    </div>
                    <div className="flex flex-col bg-white p-3 rounded-lg items-center gap-2">
                        <span>Payment Gateway :</span>
                        {loading ?
                            <LoadingSpan/>
                            :
                            <span className="font-bold text-baseColor-button">Zarin Pall</span>
                        }
                    </div>

                </div>

            </div>


        </div>
    )
}